<template>
<div class="row justify-content-md-center">

	<div class="col-12 col-xl-8">
		<!-- Title and action button section -->
		<div class="row">
			<div class="col-6">
				<h1 class="display-4">Personen beheer</h1>
			</div>

			<div class="col-6 d-flex align-items-center justify-content-end">
				<b-form-group class="m-0">
					<b-btn variant="primary"
							v-b-tooltip.hover
							title="Importeer personen"
							exact
							:to="{ name: 'personImport' }">
						<fa-icon icon="download" />
						<!-- <i class="fa fa-fw fa-file-import"></i> -->
					</b-btn>

					<b-btn variant="primary"
							v-b-tooltip.hover
							title="Persoon toevoegen"
							exact
							:to="{ name: 'personAdd' }">
						<i class="fa fa-fw fa-plus"></i>
					</b-btn>

					<b-btn variant="outline-secondary"
							v-b-tooltip.hover
							title="Terug"
							exact
							:to="{ name: 'Landingpage' }">
						<i class="fa fa-fw fa-reply"></i>
					</b-btn>
				</b-form-group>
			</div>
		</div>		

		<b-alert v-if="error"
		         variant="danger"
		         show>{{ error }}</b-alert>

		<!-- Filter section -->
		<div class="my-1 row">
			<div class="col-12">
				<filter-options person v-model="filterObj" @input="filterData" />
			</div>
		</div>

		<!-- Pagination section -->
		<div class="row">
			<div class="col-12 d-flex justify-content-end">
				<b-pagination-nav 
					v-if="persons.last_page > 1"
					:link-gen="linkGen"
					:number-of-pages="persons.last_page"
					:value="persons.current_page"
					use-router
					align="right" 
				/>
			</div>
		</div>

		<partial-loader :loading="isFetching"></partial-loader>

		<div class="row">
			<div class="col-12">
				<b-table v-if="!isFetching"
						 
						striped
						hover
						show-empty
						:items="persons.data"
						:fields="fields"
						:per-page="parseInt(persons.per_page)"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						:busy="isFetching"
						:empty-text="$t('person.listEmptyText')"
						:empty-filtered-text="$t('person.listEmptyFilteredText')">

					<template v-slot:cell(actions)="row">
						<b-btn-group class="pull-right">
							<b-btn variant="outline-primary" :to="{ name: 'personEdit', params: { personId: row.item.id } }"><i class="fa fa-fw fa-edit"></i></b-btn>
						</b-btn-group>
					</template>
				</b-table>
			</div>
		</div>

		<b-pagination-nav :link-gen="linkGen"
		                  :number-of-pages="persons.last_page"
		                  :value="persons.current_page"
		                  use-router
		                  align="right" />
	</div>
</div>
</template>

<script>
import * as _ from 'lodash';
import FilterOptions from '../../elements/Input/FilterOptions';
import PersonService from '@/services/person-service.js';
import PartialLoader from '@/components/elements/PartialLoader';
import { isCancel, CancelToken } from 'axios';
import RequestHelper from '@/helpers/request-helper';

const requestHelper = new RequestHelper();

export default {
	components: {
		FilterOptions,
		PartialLoader
	},
	data() {
		return {
			isFetching: true,
			persons: {},
			error: null,
			fields: [
				{ key: 'code', label: 'Code' },
				{ key: 'full_name_simple', label: 'Naam' },
				{ key: 'email', label: 'Email' },
				{ key: 'actions', label: 'Acties' }
			],
			perPage: 50,
			sortBy: 'id',
			sortDesc: true,
			cancelToken: null,
			filterObj: { 
				person: {
					name: 		this.$route.query.name,
					code: 		this.$route.query.code,
					email: 		this.$route.query.email,
					bid_number: this.$route.query.bid_number,
					address: 	this.$route.query.address,
				}
			}
		}

	},
	watch: {
		'$route': 'fetchData',
	},
	methods: {
		initialize() {
			this.fetchData();
		},
		linkGen(pageNumber) {
			let queryString = this.$route.query;
			queryString.page = pageNumber;

			const URL = Object.keys(queryString).map(key => key + '=' + queryString[key]).join('&');
			
			return '?' + URL;
		},
		filterData() {
			requestHelper.delayRequest(500)
				.then(() => this.$router.push({ query: {
					..._.pickBy(this.filterObj.person, _.identity)
				}}))
				.catch(rejected => {});
		},
		fetchData() {
			this.error = false;
			this.isFetching = true;
			const query = this.$route.query;

			if (!_.isNil(this.cancelToken)) {
				this.cancelToken.cancel();
			}

			this.cancelToken = CancelToken.source();

			const params = {
				total: this.perPage,
				sort: this.sortBy,
				order: this.sortDesc ? 'desc' : 'asc',
				...query
			}

			return PersonService.getAll(params, this.cancelToken.token).then(response => {
				this.isFetching = false;
				this.persons = response;
			}).catch(error => {
				if (!isCancel(error)) {
					this.isFetching = false;
					this.error = error.message;
				}
			});
		}
	},
	created() {
		this.initialize();
	}
}
</script>



// WEBPACK FOOTER //
// PersonList.vue?43d787b8